import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, withCtx as _withCtx, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 2,
  class: "ellipsis"
}
const _hoisted_2 = { key: 3 }
const _hoisted_3 = { key: 4 }

import { ref } from 'vue';
import { useGrouperStore } from 'stores/grouper-store';
import { CodeType } from 'src/contracts/codeType';
import {
    presentOnAdmissionDisplayMap,
    presentOnAdmissionMap,
    presentOnAdmissionsDisplayValues
} from 'src/common/poaUtll';
import { useSearchStore } from 'stores/search-store';
import debounce from 'lodash.debounce';
import {storeToRefs} from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'AddCode',
  props: {
    columns: {},
    type: {}
  },
  setup(__props: any) {

const props = __props;

const description = ref<string | undefined>(undefined)
const code = ref<string | undefined>(undefined);
const codeVerified = ref<string | undefined>(undefined);
const poa = ref<string>('');
const editing = ref(false);

const { readOnly } = storeToRefs(useGrouperStore());

function addRow(): void {
  const codeValue = code.value;
  if (!codeVerified.value || codeVerified.value !== codeValue || !description.value) {
    return;
  }

  if (props.type === CodeType.Diagnosis) {
    if (testCode(codeVerified.value)) {
      useGrouperStore().addDiagnosisCode(codeVerified.value, description.value, poa.value);
    }
  } else if (props.type === CodeType.Procedure) {
    useGrouperStore().addProcedureCode(codeVerified.value, description.value);
  } else {
    console.log('Unknown Code Type.')
  }

  clear();
}

function edit(value: boolean): void {
  editing.value = value;
}

function clear(): void {
  description.value = undefined;
  poa.value = '';
  code.value = undefined;
  codeVerified.value = undefined;
  editing.value = false;
}

function setPOA(poaValue: string) {
  poa.value = presentOnAdmissionDisplayMap[poaValue];
  addRow();
}

function poaLabel(): string {
    return poa.value ? presentOnAdmissionMap[poa.value] : 'Set POA';
}

const searchCodes = debounce(async (text: string | number | null) => {

  // this is safe because .length would have thrown anyway
  if (!text || typeof text === 'number' || text.length < 3) {
    return;
  }

  const searchResult = await useSearchStore().quickAddCodeSearch(text, props.type);
  description.value = searchResult?.mediumDescription || searchResult?.shortDescription || '';
  codeVerified.value = text;
  if (searchResult) {
    codeVerified.value = searchResult.value;
    code.value = searchResult.value;
  }

}, 250);

function alternateRow(): string {
  if (editing.value) {
    return 'editing-row'
  }
  else if (getRowCount() % 2 === 0) {
    return 'iodine-alternate-table-row';
  }
  return 'bg-white text-black'
}

function getRowCount(): number {
  if (props.type === CodeType.Diagnosis) {
    return useGrouperStore().diagnosisCodes?.length || 0;
  } else if (props.type === CodeType.Procedure) {
    return useGrouperStore().procedureCodes?.length  || 0;
  } else {
    return 0;
  }
}

function classNames(column: { name: string}) {
  return `io-mfe-ig-dt-col-${column.name}` + (readOnly ? ` io-mfe-ig-dt-col-${column.name}` + '-readonly': '');
}

function testCode(code: string): boolean {

  code = code.toUpperCase();
  var regExp1 = new RegExp('^[A-Z0-9]+\\.$'); // contains dot at the end
  var regExp2 = new RegExp('^[A-TU-Z][0-9][0-9AB]\\.?[0-9A-TV-Z]{0,4}'); // valid icd10 code

  return !regExp1.test(code) && regExp2.test(code);
}


return (_ctx: any,_cache: any) => {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("tr", {
    class: _normalizeClass([alternateRow(), "io-mfe-ig-add-code"])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column, index) => {
      return (_openBlock(), _createElementBlock("td", {
        key: index,
        class: _normalizeClass(classNames(column))
      }, [
        (column.name === 'code')
          ? (_openBlock(), _createBlock(_component_q_input, {
              key: 0,
              dense: "",
              outlined: "",
              modelValue: code.value,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((code).value = $event)),
                _unref(searchCodes)
              ],
              modelModifiers: { trim: true },
              disable: _unref(readOnly),
              placeholder: "Add Code",
              onKeydown: _withKeys(_withModifiers(addRow, ["prevent"]), ["enter"]),
              onFocus: _cache[1] || (_cache[1] = ($event: any) => (edit(true))),
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (edit(false)))
            }, {
              append: _withCtx(() => [
                (!code.value || description.value)
                  ? (_openBlock(), _createBlock(_component_q_icon, {
                      key: 0,
                      class: "q-pa-none",
                      name: "fa-light fa-circle-plus",
                      onClick: addRow,
                      size: "16px"
                    }))
                  : _createCommentVNode("", true),
                (description.value === '' && code.value)
                  ? (_openBlock(), _createBlock(_component_q_icon, {
                      key: 1,
                      class: "q-pa-none",
                      name: "fa-light fa-circle-exclamation",
                      size: "16px"
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue", "disable", "onUpdate:modelValue", "onKeydown"]))
          : (column.name === 'action')
            ? (_openBlock(), _createBlock(_component_q_btn_dropdown, {
                key: 1,
                disable: _unref(readOnly),
                "no-caps": "",
                dense: "",
                flat: "",
                round: "",
                class: "text-none io-mfe-ig-icon-button-small",
                "dropdown-icon": "fa-solid fa-ellipsis-vertical",
                size: "sm"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_list, null, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_q_item, { clickable: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { onClick: clear }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Clear Code")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_close_popup]
                      ]),
                      _withDirectives((_openBlock(), _createBlock(_component_q_item, { clickable: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { onClick: addRow }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_item_label, null, {
                                default: _withCtx(() => [
                                  _createTextVNode("Add Code")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })), [
                        [_directive_close_popup]
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["disable"]))
            : (column.name === 'desc')
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(description.value), 1))
              : (column.name === 'poa')
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    (code.value)
                      ? (_openBlock(), _createBlock(_component_q_btn_dropdown, {
                          key: 0,
                          flat: "",
                          unelevated: "",
                          outline: "",
                          "dropdown-icon": "fa-solid fa-caret-down",
                          label: poaLabel(),
                          class: "iodine-dropdown poa-dropdown",
                          onKeydown: _withKeys(_withModifiers(addRow, ["prevent"]), ["enter"]),
                          onFocus: edit
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_q_list, null, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(presentOnAdmissionsDisplayValues), (poa, poaIndex) => {
                                  return _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                    key: poaIndex,
                                    clickable: "",
                                    onClick: ($event: any) => (setPOA(poa))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_q_item_section, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_item_label, null, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(poa), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])), [
                                    [_directive_close_popup]
                                  ])
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["label", "onKeydown"]))
                      : _createCommentVNode("", true)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_3))
      ], 2))
    }), 128))
  ], 2))
}
}

})